<app-mobile-restriction *ngIf="showMobile"></app-mobile-restriction>

<div *ngIf="!showMobile">
    <ng2-slim-loading-bar></ng2-slim-loading-bar>
    <router-outlet></router-outlet>
    <!-- <app-options></app-options> -->
    <app-qna></app-qna>
</div>